import { commonScanDocEndPoints } from "./config"
import httpServices from "./httpServices"

export const scanDoc = async (ScanData) => {
    return await httpServices.post(commonScanDocEndPoints.imageIdentity, ScanData)
}